module.exports = __webpack_public_path__ + "static/media/1.756e99d1.png";